import moment from 'moment';

export default {
  methods: {
    $convertBase64: function (file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onload = () => {
            resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
            reject(error);
        };
      });
    },
    $isNum: function (input, withSpace = false) {
      let reg = /^\d+$/;
      if (withSpace) {
        reg = /^(?=.*\d)[\d ]+$/
      }

      return reg.test(input)
    },
    $validEmail: function (input) {
      const reg = /\S+@\S+\.\S+/;

      return reg.test(input)
    },
    $validCreditCardNumber: function (cardNumber) {
      //Validate          American Express
      //Starting with     34, 37
      //Maximum Length    15
      const regAmericanEx = /^(?:3[47][0-9]{13})$/;

      //Validate          Diners Club
      //Starting with    300 to 305, 36
      //Maximum Length   14
      const regDinnerClub = /^(?:3(?:0[0-5]|[36]|[38]|[68][0-9])[0-9]{11})$/;

      //Validate          Carte Blanche
      //Starting with     38
      //Maximum Length    14
      const regCarteBlanche = /^(?:38[0-9]{12})$/;

      //Validate          Discover
      //Starting with     6011
      //Maximum Length    16
      const regDiscover = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;

      //Validate        JCB
      //Starting with   3,2131, 1800
      //Maximum Length  15,16
      const regJCB = /^(?:(?:2131|1800|35\d{3})\d{11})$/;

      //Validate         Master Card
      //Starting with    51 -> 55, 222100 -> 272099
      //Maximum Length    16
      const regMaster = /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/;

      //Validate          Visa
      //Starting with     4
      //Maximum Length    13, 16
      const regVisa = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;

      //Validate          EnRoute
      //Starting with     2014, 2149
      //Maximum Length    15
      const regEnRoute = /^(?:2(?:014|149)[0-9]{11})$/;

      //Validate          All
      const regDefault = /^3(?:[47]\d([ -]?)\d{4}(?:\1\d{4}){2}|0[0-5]\d{11}|[68]\d{12})$|^4(?:\d\d\d)?([ -]?)\d{4}(?:\2\d{4}){2}$|^6011([ -]?)\d{4}(?:\3\d{4}){2}$|^5[1-5]\d\d([ -]?)\d{4}(?:\4\d{4}){2}$|^2014\d{11}$|^2149\d{11}$|^2131\d{11}$|^1800\d{11}$|^3\d{15}$/;

      if (regAmericanEx.test(cardNumber))
          return true;
      if (regDinnerClub.test(cardNumber))
          return true;
      if (regCarteBlanche.test(cardNumber))
          return true;
      if (regDiscover.test(cardNumber))
          return true;
      if (regJCB.test(cardNumber))
          return true;
      if (regMaster.test(cardNumber))
          return true;
      if (regVisa.test(cardNumber))
          return true;
      if (regEnRoute.test(cardNumber))
          return true;
      if (regDefault.test(cardNumber))
          return true;

      return false;
    },
    $dateFormat: function (value, format) {
      return moment(value).format(format);
    }
  },
};
